
import React, { useState } from 'react';
const modulesData = [
  {
    id: 1,
    title: "CUSTOMER RELATIONSHIP MANAGEMENT",
    scope: "Accelerates revenue growth by improving lead conversion rates, strengthening customer engagement, and giving sales teams clear visibility to close deals faster.",
    image: "/assets/img/Module/Mo1.jpg"
  },
  {
    id: 2,
    title: "PRODUCT AND SAMPLE MANAGEMENT",
    scope: "Manages products and samples across their complete lifecycle. Tracks samples from request to approval and dispatch. Enables easy conversion of samples into sales orders. Ideal for manufacturing, textiles, FMCG, pharmaceuticals, and product-based businesses.",
    image: "https://images.unsplash.com/photo-1586528116311-ad8dd3c8310d?auto=format&fit=crop&w=1000&q=80"
  },
  {
    id: 3,
    title: "RETAILS AND POINT OF SALE (POS)",
    scope: "Simplify and digitize retail sales operations by enabling fast, accurate billing across offline and online modes, while ensuring real-time integration with Inventory and Finance modules.",
    image: "https://images.pexels.com/photos/12935074/pexels-photo-12935074.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750"
  },
  {
    id: 4,
    title: "SALES AND ORDER MANAGEMENT",
    scope: "Handles the entire sales lifecycle and customer orders.",
    image: "https://images.unsplash.com/photo-1554224154-26032ffc0d07?auto=format&fit=crop&w=1000&q=80"
  },
  {
    id: 5,
    title: "COST MANAGEMENT",
    scope: "Tracks and controls business costs across procurement, production, inventory, and operations by comparing planned and actual expenses to enable accurate costing, budgeting, and profitability analysis within GNX.",
    // image: "https://images.unsplash.com/photo-1454165205744-3b78555e5572?auto=format&fit=crop&w=1000&q=80" 
    image: "/assets/img/Module/M5.avif"
  },
  {
    id: 6,
    title: "PLANNING AND MRP",
    scope: "Enables demand-driven planning and material requirement planning by forecasting demand, generating production and procurement plans, and ensuring timely availability of materials while optimizing inventory and resources in GNX.",
    // image: "https://images.unsplash.com/photo-1504384308090-c894fdcc538d?auto=format&fit=crop&w=1000&q=80" 
    image: "/assets/img/Module/M6.jpg"
  },
  {
    id: 7,
    title: "CAPACITY AND SCHEDULING MANAGEMENT",
    scope: "Optimizes machine, labor, and work center capacity to ensure balanced production schedules and on-time execution within GNX.",
    image: "https://images.unsplash.com/photo-1581092160562-40aa08e78837?auto=format&fit=crop&w=1000&q=80"
  },
  {
    id: 8,
    title: "PRODUCTION AND MANUFACTURING CONTROL",
    scope: "Manages and controls end-to-end production operations by planning, scheduling, and executing manufacturing activities to ensure optimal resource utilization, quality output, and on-time delivery within GNX.",
    // image: "https://images.unsplash.com/photo-1565034946487-077786996e27?auto=format&fit=crop&w=1000&q=80" 
    image: "/assets/img/Module/M8.jpg"
  },
  {
    id: 9,
    title: "QUALITY MANAGEMENT",
    scope: "Ensures product and process quality by defining inspection standards, conducting quality checks at every stage, managing non-conformances, and driving continuous improvement within GNX.",
    image: "https://images.unsplash.com/photo-1581092580497-e0d23cbdf1dc?auto=format&fit=crop&w=1000&q=80"
  },
  {
    id: 10,
    title: "INVENTORY AND WAREHOUSE MANAGEMENT",
    scope: "Manage inventory, stock movements, and valuation across warehouses.",
    image: "https://images.pexels.com/photos/4483610/pexels-photo-4483610.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750"
  },
  {
    id: 11,
    title: "FINANCE AND COST MANAGEMENT",
    scope: "Manages the full financial operations of the business.",
    image: "https://images.unsplash.com/photo-1460925895917-afdab827c52f?auto=format&fit=crop&w=1000&q=80"
  },
  {
    id: 12,
    title: "PLANT MAINTENANCE",
    scope: "Manages maintenance, repair, and optimization of machinery and plant assets. Reduces downtime, extends equipment life, and improves operational efficiency. Integrates maintenance with production schedules, inventory, and work orders.",
    image: "/assets/img/Module/M12.jpg"
  },
  {
    id: 13,
    title: "ASSET LIFECYCLE MANAGEMENT",
    scope: "Manage fixed assets across their complete lifecycle—from procurement and capitalization to depreciation, utilization, and disposal—while ensuring compliance with Indian and global accounting standards. The module improves asset utilization, financial accuracy, and ROI by integrating asset data with accounting, maintenance, and operations in GNX.",
    image: "https://images.pexels.com/photos/16647824/pexels-photo-16647824.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750"
  },
  {
    id: 14,
    title: "PROJECT MANAGEMENT",
    scope: "Manages project utilization across production and non-production activities, project timelines, budgets, and task execution.",
    image: "https://images.unsplash.com/photo-1531403009284-440f080d1e12?auto=format&fit=crop&w=1000&q=80"
  }
];
const ModuleSlider = () => {
  const [active, setActive] = useState(0);

  const handleNext = () => setActive((prev) => (prev + 1) % modulesData.length);
  const handlePrev = () => setActive((prev) => (prev - 1 + modulesData.length) % modulesData.length);

  return (
    <div className="centric-slider-section">
      <div className="slider-wrapper">
        <div className="section-header">
          <h1 className="main-modules-title">Functional Modules</h1>
        </div>
        {/* Navigation Arrows - Exact Position */}
        <button className="nav-btn-centric prev-btn" onClick={handlePrev}>
          <span className="arrow-icon">←</span>
        </button>
        <button className="nav-btn-centric next-btn" onClick={handleNext}>
          <span className="arrow-icon">→</span>
        </button>

        <div className="cards-stack">
          {modulesData.map((module, index) => {
            let position = index - active;
            let zIndex = modulesData.length - Math.abs(position);

            // Animation & Stack logic
            let transform = `translate3d(${position * 100}%, 0, 0)`;
            if (position < 0) transform = `translate3d(-15%, 0, 0) scale(0.9)`;
            if (position > 0) transform = `translate3d(15%, 0, 0) scale(0.9)`;
            if (position === 0) transform = `translate3d(0, 0, 0) scale(1)`;

            return (
              <div
                key={module.id}
                className={`centric-card ${position === 0 ? 'active' : ''}`}
                style={{
                  zIndex: zIndex,
                  opacity: position === 0 ? 1 : 0.3,
                  transform: transform,
                  visibility: Math.abs(position) > 1 ? 'hidden' : 'visible'
                }}
              >
                <div className="card-inner">
                  {/* Left Side: Full Image */}
                  <div className="image-panel" style={{ backgroundImage: `url(${module.image})` }}></div>

                  {/* Right Side: ID, Heading, Scope */}
                  <div className="content-panel">
                    <div className="text-container">
                      <span className="bg-id-number">{module.id < 10 ? `0${module.id}` : module.id}</span>
                      <h2 className="module-title">{module.title}</h2>
                      <div className="blue-bar"></div>
                      <p className="scope-text"><strong>Scope:</strong> {module.scope}</p>
                    </div>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default ModuleSlider;